import { APIClient } from "./axiosClient";

const api = new APIClient();
const path = "/stores";

const storeApi = {
  verifyBusinessNumber(params: any): Promise<any> {
    const url = `${path}/verify-business-number`;
    return api.get(url, params);
  },

};

export default storeApi;
